import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import Person from '../../models/core/userRole/Person';
import { ATUALIZA_ACESSO_PRONTUARIO, FETCH_PERSON, FETCH_PERSON_DEPENDENTE } from '../actions/person';
 
interface IPersonReducer{ 
    pessoa: Person | null;
    pessoaDependente: Person | null;
    acessoProntuario: any;    
}
 
const initialState: IPersonReducer = {
    pessoa: null,
    pessoaDependente: null,
    acessoProntuario: false
} 
 
export const PersonReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case FETCH_PERSON:{
            return{
                ...cloneDeep(state),
                pessoa: action.pessoa,
            }
        }
        case FETCH_PERSON_DEPENDENTE:{
            return{
                ...cloneDeep(state),
                pessoaDependente: action.pessoaDependente
            }
        }
        case ATUALIZA_ACESSO_PRONTUARIO:{
            return{
                ...cloneDeep(state),
                acessoProntuario: action.acessoProntuario
            }
        }
        
        default:{
           return state
       }
   }
}
 